import assertEventType from 'common/bento/lib/assertEventType';
import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { SavePersonalAddressDocument } from '../graphql/mutations/savePersonalAddress.gql';
import { Model } from './model';

export enum Service {
  SaveAddress = 'saveAddress',
}

const services: MachineServices<Model, Service> = {
  saveAddress: async (_, event) => {
    assertEventType(event, 'SUBMIT_ADDRESS');

    const { city, street, streetAddition, zip } = event.data;

    return apolloClient.mutate({
      mutation: SavePersonalAddressDocument,
      variables: {
        input: {
          city,
          street,
          streetAddition,
          zip,
        },
      },
    });
  },
};

export default services;
